import { Injectable } from '@angular/core';
import { Observable, Subject, filter } from 'rxjs';
import { Alert, AlertOptions, AlertType } from '../data/interfaces/alert';

@Injectable({ providedIn: 'root' })
export class AlertService {
    private subject = new Subject<Alert>();
    private defaultId = 'default-alert';

    onAlert(id = this.defaultId): Observable<Alert> {
        return this.subject.asObservable().pipe(filter(x => x && x.id === id));
    }

    success(message: string, options?: AlertOptions): void {
        this.alert(new AlertModel({ ...options, type: AlertType.Success, message }));
    }

    error(message: string, options?: AlertOptions): void {
        this.alert(new AlertModel({ ...options, type: AlertType.Error, message }));
    }

    info(message: string, options?: AlertOptions): void {
        this.alert(new AlertModel({ ...options, type: AlertType.Info, message }));
    }

    warn(message: string, options?: AlertOptions): void {
        this.alert(new AlertModel({ ...options, type: AlertType.Warning, message }));
    }

    alert(alert: Alert): void {
        alert.id = alert.id || this.defaultId;
        alert.autoClose = alert.autoClose ?? true;
        this.subject.next(alert);
    }

    clear(id = this.defaultId): void {
        this.subject.next({ id } as Alert);
    }
}

class AlertModel implements Alert {
    id?: string;
    type?: AlertType;
    message?: string;
    autoClose?: boolean;
    keepAfterRouteChange?: boolean;
    fade?: boolean;

    constructor(init?: Partial<Alert>) {
        Object.assign(this, init);
    }
}
